import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { PublicShell } from "../components/PublicShell";
import { CodeGate } from "../components/CodeGate";
import { Card, ErrorBox, Spinner } from "../components/kd";
import { StatusBadge } from "../components/Badges";
import { fmtDate } from "../lib/format";

const DEFAULT_SLUG = process.env.REACT_APP_DEFAULT_PRAXIS_SLUG || "musterpraxis";

export default function MyCases() {
  const [sp] = useSearchParams();
  const slug = sp.get("praxis") || DEFAULT_SLUG;
  const [praxis, setPraxis] = useState<any>(null);
  const [cases, setCases] = useState<any[] | null>(null);
  const [err, setErr] = useState("");

  const load = () => api.get(`/public/praxis/${slug}/meine-faelle`).then((r) => setCases(r.data));
  useEffect(() => {
    api.get(`/public/praxis/${slug}`).then((r) => setPraxis(r.data)).catch((e) => setErr(errMsg(e)));
    api.get(`/public/praxis/${slug}/sitzung`).then((r) => { if (r.data.angemeldet) load(); }).catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  if (!praxis) return <PublicShell>{err ? <Card><ErrorBox>{err}</ErrorBox></Card> : <Spinner />}</PublicShell>;
  return (
    <PublicShell praxis={praxis}>
      {cases === null ? (
        <Card>
          <CodeGate
            title="Meine Fälle"
            intro="Bestätigen Sie die E-Mail-Adresse Ihrer Praxis, um alle Ihre Überweisungen an diese Fachpraxis zu sehen."
            onRequest={(email) => api.post(`/public/praxis/${slug}/code`, { email })}
            onVerify={async (email, code) => { await api.post(`/public/praxis/${slug}/code/pruefen`, { email, code }); await load(); }}
          />
        </Card>
      ) : (
        <>
          <h1 className="mb-5">Meine Fälle</h1>
          {cases.length === 0 && <Card><p className="text-text-muted">Für diese E-Mail-Adresse liegen keine Fälle vor.</p></Card>}
          <ul className="space-y-3" data-testid="my-cases-list">
            {cases.map((c) => (
              <li key={c.zugriffs_token}>
                <a href={`/f/${c.zugriffs_token}`} className="kd-card flex items-center justify-between gap-3 p-4 text-text no-underline transition-colors hover:border-primary" data-testid={`my-case-${c.fallnummer}`}>
                  <div className="min-w-0">
                    <p className="whitespace-nowrap font-semibold">{c.fallnummer}</p>
                    <p className="text-sm text-text-muted">{c.patient} · {c.grund} · {fmtDate(c.erstellt_am)}</p>
                  </div>
                  <div className="flex items-center gap-2"><StatusBadge status={c.status} /><ChevronRight className="h-5 w-5 text-text-muted" aria-hidden /></div>
                </a>
              </li>
            ))}
          </ul>
        </>
      )}
    </PublicShell>
  );
}
